import { createSlice } from "@reduxjs/toolkit";

const defaultFilters = {
    start_date: null,
    end_date: null,
    region_ids: [],
    product_ids: [],
    created_by_ids: [],
    payment_status: null,
    payment_type: null,
    role: null,
    is_active: null,
    is_b2b: null,
    format: "json",
};

const initialState = {
    // Current active report type
    activeReportType: "orders", // orders, warranty, insurance, customers, users, sales-funnel, dashboard

    // Filters for each report type
    filters: {
        orders: { ...defaultFilters },
        warranty: { ...defaultFilters },
        insurance: { ...defaultFilters },
        customers: { ...defaultFilters },
        users: { ...defaultFilters },
        "sales-funnel": { ...defaultFilters },
        dashboard: { ...defaultFilters },
    },

    // Report data
    reportData: {
        orders: null,
        warranty: null,
        insurance: null,
        customers: null,
        users: null,
        "sales-funnel": null,
        dashboard: null,
    },

    // Loading states
    loading: {
        orders: false,
        warranty: false,
        insurance: false,
        customers: false,
        users: false,
        "sales-funnel": false,
        dashboard: false,
    },

    // Error states
    errors: {
        orders: null,
        warranty: null,
        insurance: null,
        customers: null,
        users: null,
        "sales-funnel": null,
        dashboard: null,
    },

    // Export states
    exporting: {
        orders: false,
        warranty: false,
        insurance: false,
        customers: false,
        users: false,
        "sales-funnel": false,
        dashboard: false,
    },
};

export const reportsSlice = createSlice({
    name: "reports",
    initialState,
    reducers: {
        // Set active report type
        setActiveReportType: (state, action) => {
            state.activeReportType = action.payload;
        },

        // Update filters for specific report type
        updateFilters: (state, action) => {
            const { reportType, filters } = action.payload;
            state.filters[reportType] = { ...state.filters[reportType], ...filters };
        },

        // Reset filters for specific report type
        resetFilters: (state, action) => {
            const reportType = action.payload;
            state.filters[reportType] = { ...defaultFilters };
        },

        // Set report data
        setReportData: (state, action) => {
            const { reportType, data } = action.payload;
            state.reportData[reportType] = data;
        },

        // Set loading state
        setLoading: (state, action) => {
            const { reportType, loading } = action.payload;
            state.loading[reportType] = loading;
        },

        // Set error state
        setError: (state, action) => {
            const { reportType, error } = action.payload;
            state.errors[reportType] = error;
        },

        // Set exporting state
        setExporting: (state, action) => {
            const { reportType, exporting } = action.payload;
            state.exporting[reportType] = exporting;
        },

        // Clear all report data
        clearAllReports: (state) => {
            state.reportData = {
                orders: null,
                warranty: null,
                insurance: null,
                customers: null,
                users: null,
                "sales-funnel": null,
                dashboard: null,
            };
            state.errors = {
                orders: null,
                warranty: null,
                insurance: null,
                customers: null,
                users: null,
                "sales-funnel": null,
                dashboard: null,
            };
        },

        // Clear specific report data
        clearReportData: (state, action) => {
            const reportType = action.payload;
            state.reportData[reportType] = null;
            state.errors[reportType] = null;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    setActiveReportType,
    updateFilters,
    resetFilters,
    setReportData,
    setLoading,
    setError,
    setExporting,
    clearAllReports,
    clearReportData,
} = reportsSlice.actions;

export default reportsSlice;
